module.exports = __webpack_public_path__ + "static/img/ico_cart_wh_m.5cb58dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ico_cart_wh_m.png
// module id = 7FP3
// module chunks = 10